const masks = {
    cpf(value) {
        return value
            .replace(/\D+/g, "")
            .replace(/(\d{3})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d{1,2})/, "$1-$2")
            .replace(/(-\d{2})\d+?$/, "$1");
    },

    cnpj(value) {
        return value
            .replace(/\D+/g, "")
            .replace(/(\d{2})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d)/, "$1/$2")
            .replace(/(\d{4})(\d)/, "$1-$2")
            .replace(/(-\d{2})\d+?$/, "$1");
    },

    phone(value) {
        return value
            .replace(/\D+/g, "")
            .replace(/(\d{2})(\d)/, "($1) $2")
            .replace(/(\d{4})(\d)/, "$1-$2")
            .replace(/(\d{4})-(\d)(\d{4})/, "$1$2-$3")
            .replace(/(-\d{4})\d+?$/, "$1");
    },

    cep(value) {
        return value
            .replace(/\D+/g, "")
            .replace(/(\d{5})(\d)/, "$1-$2")
            .replace(/(-\d{3})\d+?$/, "$1");
    },

    pis(value) {
        return value
            .replace(/\D+/g, "")
            .replace(/(\d{3})(\d)/, "$1.$2")
            .replace(/(\d{5})(\d)/, "$1.$2")
            .replace(/(\d{5}\.)(\d{2})(\d)/, "$1$2-$3")
            .replace(/(-\d)\d+?$/, "$1");
    },

    money(value) {
        const cleanValue = +value.replace(/\D+/g, "");
        const options = { style: "currency", currency: "BRL" };
        return new Intl.NumberFormat("pt-br", options).format(cleanValue / 100);
    },

    date(value) {
        return value
            .replace(/\D+/g, "")
            .replace(/(\d{2})(\d)/, "$1/$2")
            .replace(/(\/\d{2})(\d)/, "$1/$2")
            .replace(/(\/\d{4})\d+?$/, "$1");
    },

    dateWithDashes(value) {
        return value
            .replace(/\D+/g, "")
            .replace(/(\d{2})(\d)/, "$1-$2")
            .replace(/(-\d{2})(\d)/, "$1-$2")
            .replace(/(-\d{4})\d+?$/, "$1");
    },
};

document.querySelectorAll("input").forEach(($input) => {
    const field = $input.dataset.js;

    $input.addEventListener(
        "input",
        (e) => {
            e.target.value = masks[field](e.target.value);
        },
        false
    );
});

function maskDocument(o, f) {
    v_obj = o
    v_fun = f
    setTimeout('execmask()', 1)
}

function execmask() {
    v_obj.value = v_fun(v_obj.value)
}

function cpfCnpj(v) {

    //Remove tudo o que não é dígito
    v = v.replace(/\D/g, "")

    if (v.length <= 14) { //CPF
        v = v.replace(/(\d{3})(\d)/, "$1.$2")
        v = v.replace(/(\d{3})(\d)/, "$1.$2")
        v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    } else { //CNPJ
        v = v.replace(/^(\d{2})(\d)/, "$1.$2")
        v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
        v = v.replace(/\.(\d{3})(\d)/, ".$1/$2")
        v = v.replace(/(\d{4})(\d)/, "$1-$2")
    }

    return v

}

document.addEventListener("DOMContentLoaded", function() {
  var documentos = document.querySelectorAll('.document');

  documentos.forEach(function(el) {
    var texto = el.textContent || el.innerText;
    var textoLimpo = texto.replace(/\D/g, ''); // Remove caracteres não numéricos

    if (textoLimpo.length === 14) {
      // Primeiro tenta validar como CNPJ
      if (validaCNPJ(textoLimpo)) {
        el.textContent = formataCNPJ(textoLimpo); // Formata como CNPJ se for válido
      } else {
        // Caso não seja um CNPJ válido, trata como CPF
        var cpfSemZeros = textoLimpo.replace(/^0+/, ''); // Remove os zeros à esquerda
        if (cpfSemZeros.length === 11) {
          el.textContent = formataCPF(cpfSemZeros); // Formata o CPF sem os zeros à esquerda
        }
      }
    }
  });

  function formataCPF(cpf) {
    console.log('CPF');
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  function formataCNPJ(cnpj) {
    console.log('CNPJ');
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  // Função para validar CNPJ
  function validaCNPJ(cnpj) {
    // Elimina CNPJs inválidos conhecidos
    if (cnpj === "00000000000000" || cnpj === "11111111111111" ||
      cnpj === "22222222222222" || cnpj === "33333333333333" ||
      cnpj === "44444444444444" || cnpj === "55555555555555" ||
      cnpj === "66666666666666" || cnpj === "77777777777777" ||
      cnpj === "88888888888888" || cnpj === "99999999999999" ||
      cnpj.length !== 14) {
      return false;
    }

    // Validação dos dígitos verificadores
    var tamanho = cnpj.length - 2;
    var numeros = cnpj.substring(0, tamanho);
    var digitos = cnpj.substring(tamanho);
    var soma = 0;
    var pos = tamanho - 7;
    for (var i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0)) {
      return false;
    }

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (var i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1)) {
      return false;
    }

    return true; // CNPJ válido
  }
});
